
import gsap from 'gsap'

export function runExitAnimation (onComplete = () => {}) {
  const loading = document.querySelector('.loading-screen')
  const situation = document.querySelector('.situationRoom')

  if (!loading || !situation) {
    onComplete()
    return
  }

  const tl = gsap.timeline({ onComplete })

  tl.to(loading, {
    y: '-100%',
    duration: 1,
    opacity: 1,
    ease: 'power2.inOut'
  }, 0)

  tl.to(situation, {
    y: '0%',
    duration: 1,
    ease: 'power2.inOut'
  }, 0)
}
